import './MissionReportList.sass';
import dock3Image from 'src/assets/img/dock-3.png';
import { useEffect, useState } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import Progress from 'src/hci/common/Progress/Progress';
import { TbBolt, TbEyeglassOff, TbHourglassEmpty, TbUser } from 'react-icons/tb';
import Badge from 'src/hci/common/Badge/Badge';
import { formatDuration } from 'src/helper/utils';
import Loading from 'src/hci/common/Loading/Loading';
import Avatar from 'src/hci/common/Avatar/Avatar';
import Select from 'src/hci/common/Select/Select';
import MessageArea from 'src/hci/organism/MessageArea/MessageArea';

function MissionReportList({ deviceInfo, missions, devices, selectedMissionId, onMissionSelection, onDeviceChane, sideView = false, isPublic = false }) {
  const handleMissionSelection = (missionId) => {
    const mission = missions.find(mission => mission.id === missionId);
    onMissionSelection?.(mission);
  };

  const handleDeviceChange = (deviceId) => {
    onDeviceChane?.(deviceId);
  }
  
  return (
    <div className={classNames("mission-report-list", {'side-view': sideView})}>
      <div className="list-header">
        <div className="title">{deviceInfo ? `Mission Reports for ${deviceInfo?.name}` : 'Mission Reports'}</div>
        {devices ? (
          <div className="right-section">
            <span>Device:</span>
            <Select
              value={deviceInfo?.id || deviceInfo?.Id} 
              onValueChange={value => handleDeviceChange(value)}
              placeholder="Please select the device" 
              content={[{
                items: devices?.map(item => ({ value: item.id, label: item.name }))
              }]} 
              className="device-select"
            />
          </div>
        ) : null}
      </div>
      <div className="mission-list">
        {missions?.length ? missions.map(mission => (
          <div key={mission.id} className={classNames("mission-item", {selected: mission.id === selectedMissionId})} onClick={() => handleMissionSelection(mission.id)}>
            <div className="main-info">
              <div className="mission-name">{mission.name}</div>
              <div className="mission-date">{moment(mission.startTime).format('MMM DD, YYYY HH:mm:ss')}</div>
            </div>
            {!isPublic && <>
              <div className="device-info">
                <img className="device-image" src={dock3Image} />
                <div className="main">
                  <div className="device-name">{mission.dock?.name}</div>
                  <div className="device-description">DJI Dock</div>
                </div>
              </div>
              <div className="owner-info">
                <Avatar image={mission.createdBy?.avatar} />
                <div className="main">
                  <div className="owner-name">{mission.createdBy?.displayName}</div>
                  <div className="owner-description">Mission Owner</div>
                </div>
              </div>
            </>}
            <div className="status-info">
              <div className="info-items">
                <Badge color="green" variant="outline">{ mission.status?.toUpperCase() }</Badge>
                <div className="item">
                  <TbHourglassEmpty className="icon" />
                  <div className="value">
                    {mission?.endTime ? formatDuration(mission.endTime - mission.startTime) : 'N/A'}
                  </div>
                </div>
                <div className="item">
                  <TbBolt className="icon" />
                  <div className="value">Manual Flight</div>
                </div>
              </div>
              <div className="status-bar">
                <div className="time">{moment(mission.startTime).format('HH:mm')}</div>
                <Progress value={100} text={false} className="progress" backColor="var(--ir-color-surface-3)" />
                <div className="time">{moment(mission.endTime).format('HH:mm')}</div>
              </div>
            </div>
          </div>
        )) : !missions ? (
          <Loading message="Loading missions..." />
        ) : (
          <MessageArea
            title="No missions found"
            description="There are no missions available for the selected device."
            icon={TbEyeglassOff}
            className="no-mission"
          />
        )}
      </div>
    </div>
  )
}

export default MissionReportList